'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('formdata-polyfill');
require('./_index.scss.js');

var CLASSNAME = 'varta-form';
/**
 * 
 */

var Form = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Form, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Form);

  function Form() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Form);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "form", /*#__PURE__*/React__default.createRef());

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onSubmit", function (e, options) {
      if (e) {
        e.preventDefault();
      }

      var _this$props = _this.props,
          onSubmitError = _this$props.onSubmitError,
          onSubmitSuccess = _this$props.onSubmitSuccess;
      var formData = new FormData(_this.form.current);
      formData = _this.formDataToJson(formData);

      if (!_this.form.current.checkValidity()) {
        _rollupPluginBabelHelpers.toConsumableArray(_this.form.current.elements).forEach(function (el) {
          return el.checkValidity();
        });

        onSubmitError(formData, options);
        return false;
      }

      onSubmitSuccess(formData, options);
      return formData;
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Form, [{
    key: "formDataToJson",
    value: function formDataToJson(formData) {
      var object = {};
      var formDataEntries = formData.entries();
      var formDataEntry = formDataEntries.next();

      while (!formDataEntry.done) {
        var _formDataEntry$value = _rollupPluginBabelHelpers.slicedToArray(formDataEntry.value, 2),
            key = _formDataEntry$value[0],
            value = _formDataEntry$value[1];

        if (!Reflect.has(object, key)) {
          object[key] = value;
          formDataEntry = formDataEntries.next();
          continue;
        }

        if (!Array.isArray(object[key])) {
          object[key] = [object[key]];
        }

        object[key].push(value);
        formDataEntry = formDataEntries.next();
      }

      return object;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children,
          id = _this$props2.id,
          onChange = _this$props2.onChange,
          style = _this$props2.style;
      return /*#__PURE__*/React__default.createElement("form", {
        onSubmit: this.onSubmit,
        className: classNames(className, CLASSNAME),
        ref: this.form,
        id: id,
        onChange: onChange,
        style: style
      }, children);
    }
  }]);

  return Form;
}(React__default.Component);
Form.propTypes = {
  /** Child nodes */
  children: PropTypes.node,

  /** Additional class name */
  className: PropTypes.string,

  /** Id is form */
  id: PropTypes.string,

  /** Callback function on change */
  onChange: PropTypes.func,

  /** Callback function on error */
  onSubmitError: PropTypes.func,

  /** Callback function on success */
  onSubmitSuccess: PropTypes.func,

  /** Additional style object */
  style: PropTypes.shape()
};
Form.defaultProps = {
  onChange: function onChange() {
    return void 0;
  },
  onSubmitError: function onSubmitError() {
    return void 0;
  },
  onSubmitSuccess: function onSubmitSuccess() {
    return void 0;
  }
};

module.exports = Form;
